var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesCardImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.879 42.1509V47.226C26.879 51.526 22.8789 55.0009 17.9539 55.0009C13.0289 55.0009 9.00391 51.526 9.00391 47.226V42.1509C9.00391 46.4509 13.0039 49.5009 17.9539 49.5009C22.8789 49.5009 26.879 46.4259 26.879 42.1509Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.875 35.275C26.875 36.525 26.525 37.6749 25.925 38.6749C24.45 41.0999 21.425 42.625 17.925 42.625C14.425 42.625 11.4 41.0749 9.92496 38.6749C9.32496 37.6749 8.9751 36.525 8.9751 35.275C8.9751 33.125 9.97504 31.2 11.575 29.8C13.2 28.375 15.425 27.525 17.9 27.525C20.375 27.525 22.6 28.4 24.225 29.8C25.875 31.175 26.875 33.125 26.875 35.275Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.879 35.275V42.15C26.879 46.45 22.8789 49.5 17.9539 49.5C13.0289 49.5 9.00391 46.425 9.00391 42.15V35.275C9.00391 30.975 13.0039 27.5 17.9539 27.5C20.4289 27.5 22.654 28.3749 24.279 29.7749C25.879 31.1749 26.879 33.125 26.879 35.275Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27.4249V32.5751C55 33.9501 53.9 35.075 52.5 35.125H47.6C44.9 35.125 42.4251 33.15 42.2001 30.45C42.0501 28.875 42.65 27.4 43.7 26.375C44.625 25.425 45.9 24.875 47.3 24.875H52.5C53.9 24.925 55 26.0499 55 27.4249Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 26.25V21.25C5 14.45 9.10001 9.69999 15.475 8.89999C16.125 8.79999 16.8 8.75 17.5 8.75H40C40.65 8.75 41.275 8.77497 41.875 8.87497C48.325 9.62497 52.5 14.4 52.5 21.25V24.875H47.3C45.9 24.875 44.625 25.425 43.7 26.375C42.65 27.4 42.05 28.875 42.2 30.45C42.425 33.15 44.8999 35.125 47.5999 35.125H52.5V38.75C52.5 46.25 47.5 51.25 40 51.25H33.75",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesCardImage);
export default __webpack_public_path__ + "static/media/sales-card-image.c15445f74d01ff3682584f0655eb5a59.svg";
export { ForwardRef as ReactComponent };